import type { Action } from 'redux';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const UpdateSelectedAdLink = new ReduxAsyncAction<
  'UPDATE_SELECTED_AD_LINK',
  Record<string, any>,
  { selectedAdLink: Record<string, any> }
>('UPDATE_SELECTED_AD_LINK');

UpdateSelectedAdLink.registerRequest(async (selectedAdLink: Record<string, any>) => {
  return { selectedAdLink };
});

export const UPDATE_SELECTED_AD_LINK = UpdateSelectedAdLink.actionNamespaceConstants;
export const updateSelectedAdLink = UpdateSelectedAdLink.request;

export type UpdateSelectedAdLinkResponseAction = Action<typeof UPDATE_SELECTED_AD_LINK.response> & {
  data: { selectedAdLink: Record<string, any> };
};
